import React from 'react';
import moment from 'moment';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';

import { useDispatch, useSelector } from 'react-redux';
import { scheduleCalendarSelector } from '@store/policies/schedule/selectors';
import { setForm } from '@store/policies/schedule/actions';

import { scheduleStatus } from '@store/policies/schedule/utils';
import { formatRecordForForm } from './utils';
import { TableWrapper } from './styled';

const timeDisplayFormat: any = {
  hour: 'numeric',
  minute: '2-digit',
  hour12: false,
};

const ScheduleCalender = ({ canEdit }) => {
  const dispatch = useDispatch();
  const events = useSelector(scheduleCalendarSelector);

  const handleEventClick = ({ event }) => {
    const formData: any = formatRecordForForm({ ...event.extendedProps, id: event.id });
    if (formData.state !== scheduleStatus.pending) {
      return;
    }
    dispatch(setForm(formData));
  };

  return (
    <TableWrapper>
      <FullCalendar
        plugins={[momentTimezonePlugin, dayGridPlugin, timeGridPlugin, listPlugin]}
        timeZone={moment().tz()}
        initialView="dayGridMonth"
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,listWeek',
        }}
        eventDisplay="list-item"
        events={events}
        eventClick={canEdit ? handleEventClick : undefined}
        allDaySlot={false}
        // height={700}
        aspectRatio={2.5}
        eventTimeFormat={timeDisplayFormat}
        slotLabelFormat={timeDisplayFormat}
      />
    </TableWrapper>
  );
};

export default ScheduleCalender;
